document.addEventListener("DOMContentLoaded", function () {
    const compareElements = document.querySelectorAll(
        ".sc-before-after-images__wrapper"
    );
    console.log(compareElements);

    compareElements.forEach((container) => {
        console.log(container);
        let active = false;

        const scroller = container.querySelector(".compare-scroller");
        const wrapper = container.querySelector(".compare-image-wrapper");
        const after = container.querySelector(".after");

        function scrollIt(x) {
            let transform = Math.max(0, Math.min(x, wrapper.offsetWidth));
            after.style.width = transform + 2 + "px";
            scroller.style.left = transform + "px";
        }

        scroller.addEventListener("mousedown", function () {
            active = true;
            scroller.classList.add("scrolling");
        });

        document.body.addEventListener("mouseup", function () {
            active = false;
            scroller.classList.remove("scrolling");
        });
        
        document.body.addEventListener("mouseleave", function () {
            active = false;
            scroller.classList.remove("scrolling");
        });

        document.body.addEventListener("mousemove", function (e) {
            if (!active) return;
            let x = e.pageX - wrapper.getBoundingClientRect().left;
            scrollIt(x);
        });

        scroller.addEventListener("touchstart", function () {
            active = true;
            scroller.classList.add("scrolling");
        });
        
        document.body.addEventListener("touchend", function () {
            active = false;
            scroller.classList.remove("scrolling");
        });
        
        document.body.addEventListener("touchcancel", function () {
            active = false;
            scroller.classList.remove("scrolling");
        });

        window.addEventListener("touchmove", function (e) {
            if (!active) return;
            let x =
            e.changedTouches[0].pageX - wrapper.getBoundingClientRect().left;
            scrollIt(x);
        });

        wrapper.addEventListener("click", function (e) {
            let x = e.pageX - wrapper.getBoundingClientRect().left;
            scrollIt(x);
        });

        scrollIt(wrapper.offsetWidth / 2);
    });
});